import React from "react";
import { IonIcon, IonItem, IonLabel } from "@ionic/react";
import {
  chevronDownOutline as downIcon,
  chevronUpOutline as upIcon,
  checkmark,
} from "ionicons/icons";

import { EXPERIENCE_DATA } from "../../constants/experienceConstant";

import styles from "./ExperienceSelectForm.module.scss";

export interface ExperienceSelectFormProps {
  checkedExperienceNos?: number[];
  update: (args: { [key: string]: any }) => void;
  isOpen?: boolean;
}

const ExperienceSelectForm = (props: ExperienceSelectFormProps) => {
  const { checkedExperienceNos, update, isOpen = false } = props;
  const experiences = React.useMemo(() => {
    return EXPERIENCE_DATA.map(e => ({
      ...e,
      // チェックマークのみを表示するため、checkedStylesは使用しない
      checked: Boolean(checkedExperienceNos?.includes(e.no)),
    }));
  }, [checkedExperienceNos]);

  // 表示名の生成
  const getSelectedExperienceLabels = () => {
    if (!checkedExperienceNos?.length) return null;
    return checkedExperienceNos
      .map(no => experiences.find(e => e.no === no)?.label)
      .filter(Boolean)
      .join("、");
  };

  // トグル処理
  const toggleDropdown = () => {
    update({ showExperienceForm: !isOpen });
  };

  // 項目選択処理
  const handleItemClick = (expNo: number) => {
    if (checkedExperienceNos?.includes(expNo)) {
      // 選択解除
      const filteredExpNos = checkedExperienceNos.filter(id => id !== expNo);
      update({ experience_nos: filteredExpNos });
    } else {
      // 選択追加
      update({
        experience_nos: [...(checkedExperienceNos || []), expNo],
      });
    }
  };

  // 項目リスト生成
  const renderExperienceItems = () => {
    return experiences.map(exp => {
      const isSelected = checkedExperienceNos?.includes(exp.no);
      const checkIcon = isSelected && (
        <IonIcon slot="end" icon={checkmark} className={styles.checkIcon} />
      );

      // 左側のカラーバーのスタイルを設定
      const itemStyle = {
        "--color-bar": exp.styles.color,
      } as React.CSSProperties;

      return (
        <li
          key={exp.no}
          className={styles.experienceItem}
          style={itemStyle}
          onClick={() => handleItemClick(exp.no)}
        >
          <div className={styles.expName}>
            {exp.label}
            {checkIcon}
          </div>
        </li>
      );
    });
  };

  return (
    <div className={styles.experienceNos}>
      <IonItem className={styles.experienceItemToggle} onClick={toggleDropdown}>
        <IonLabel color="light" className={styles.title}>
          意識すること
        </IonLabel>
        <div className={styles.selectedNames}>
          {getSelectedExperienceLabels() || "選択しない"}
        </div>
        {isOpen ? (
          <IonIcon icon={upIcon} slot="end" className={styles.arrowIcon} />
        ) : (
          <IonIcon icon={downIcon} slot="end" className={styles.arrowIcon} />
        )}
      </IonItem>
      <div className={isOpen ? styles.experienceArea : styles.close}>
        <ul className={styles.experienceSelector}>{renderExperienceItems()}</ul>
      </div>
    </div>
  );
};

export default ExperienceSelectForm;
